import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path
      d="M10.5 19H7.5L14.5 13H9.5L12 11H16H19.5H23L20.5 13H17.5L10.5 19Z"
      fill="#ccc"
    />
    <path d="M2.5 4V7H7.5V19H10.5V7H15.5V4H2.5Z" />
  </React.Fragment>,
  `Enhancer`
);
